// ¿El checkout online muestra la casilla OPCIONAL de promociones del restaurante?
//
// APAGADA el 2026-10-01 por decisión de Samuel: primero los SMS de pedidos al
// 100% en Twilio. La campaña A2P transaccional (CM4fffe046…) se rechazó tres
// veces con 30908 y Twilio Support (ticket #29787933) contestó que, mientras la
// pantalla de opt-in muestre una casilla de promociones, la campaña tiene que
// declarar ejemplos de marketing. El checkout online ES la pantalla de opt-in
// registrada, así que la casilla sale de ahí.
//
// Para volver a encenderla hace falta, en el MISMO PR: el apartado de
// promociones en /privacy y /sms-opt-in (ver el revert de #2303) y una campaña
// que declare los mensajes de marketing. El kiosko no se toca: no es parte del
// registro.
export const ONLINE_CHECKOUT_PROMO_BOX_ENABLED = false
